module.exports = __webpack_public_path__ + "img/socials-3.a781a668.svg";